import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { STATUS } from '../utils/status';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';

const convertTimestampToDate = (project) => {
    return {
        ...project,
        timeStamp: project.timeStamp.toDate().toISOString(),
    };
};


const initialState = {
    konumdata: [],
    konumstatus: STATUS.IDLE,
    konumerror: null,
};

export const fetchKonum = createAsyncThunk('projects/fetchKonum', async () => {
    const querySnapshot = await getDocs(collection(db, 'konum'));
    let konum = [];
    querySnapshot.forEach((doc) => {
        konum.push({ id: doc.id, ...convertTimestampToDate(doc.data()) });
    });
    return konum;
});


const konumSlice = createSlice({
    name: 'konum',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchKonum.pending, (state) => {
                state.konumstatus = STATUS.LOADING;
            })
            .addCase(fetchKonum.fulfilled, (state, action) => {
                state.konumstatus = STATUS.SUCCESS;
                state.konumdata = action.payload;
            })
            .addCase(fetchKonum.rejected, (state, action) => {
                state.konumstatus = STATUS.FAIL;
                state.konumerror = action.error.message;
            })
    },
});

export default konumSlice.reducer;
